import { Control } from 'react-hook-form';
import { LwFormMultiSelect } from 'redesign';
import { useSiteDetection } from 'shared/hooks';
import { useGetCompanyPartners } from 'ogp/components/views/management/workflows/hooks/use-get-company-partners';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { ActionNodeFormValues } from '../action-node-editor.types';

export const ForwardToPartnersContent = ({
  formControl,
}: {
  formControl: Control<ActionNodeFormValues>;
}) => {
  const { site } = useSiteDetection();
  const companyPartnersQuery = useGetCompanyPartners(site);

  if (companyPartnersQuery.status !== 'success') {
    return <RenderUnsettledUI data={companyPartnersQuery} />;
  }

  return (
    <LwFormMultiSelect
      name="partnerIds"
      label="Partners"
      data-testid="action-partnerIds"
      control={formControl}
      options={companyPartnersQuery.data}
      rules={{ required: true }}
      getOptionLabel={(option) => option.label}
      getOptionKey={(option) => option.value}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      enableSelectAll={true}
    />
  );
};
